import { Notice } from '../../Model/Notice';
import { NoticeRepository, CreateNoticeDTO } from '../Repositories/NoticeRepository';

export class CreateNoticeUseCase {
  constructor(private repo: NoticeRepository) {}
  execute(dto: CreateNoticeDTO): Promise<Notice> {
    return this.repo.create(dto).then(r => r).catch(err => Promise.reject(err));
  }
}
